﻿export class RG<T> {
    constructor(
        public version: string,
        public responseType: any,
        public data: T,
        public pagination: any,
    ) { }
}